<template>
  <span class="ual-wrap">
    <button type="button" class="ual" :title="title" @click.stop.prevent="open = true">
      <slot>{{ label || userName || email || userId || 'N/A' }}</slot>
    </button>
    <UserActivityModal
      v-if="open"
      :user-id="userId"
      :email="email"
      :user-name="userName"
      @close="open = false"
    />
  </span>
</template>

<script>
import UserActivityModal from "@/components/pages/Models/UserActivityModal.vue";

// A clickable user name that opens the full user-activity modal (details +
// logins + page views + posts + messages) in place — no navigation away.
// Drop-in replacement for <UserLink> where a modal is preferred.
export default {
  name: "UserActivityLink",
  components: { UserActivityModal },
  props: {
    userId: { type: [String, Number], default: "" },
    email: { type: String, default: "" },
    userName: { type: String, default: "" },
    label: { type: String, default: "" },
    title: { type: String, default: "View full user activity" },
  },
  data() {
    return { open: false };
  },
};
</script>

<style scoped>
.ual-wrap { display: inline; }
.ual {
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  font: inherit;
  color: var(--g-blue, #3467d5);
  cursor: pointer;
  text-decoration: none;
}
.ual:hover {
  text-decoration: underline;
}
</style>
